import ReactDOM from 'react-dom';

export const POPOVER_CONTAINER_ID = 'popoverContainer';
export const POPOVER_LVL2_CONTAINER_ID = 'popoverContainerLvl2';
// for popups in fixed elements outside the scrollContainer (eg., side panel)
export const GLOBAL_POPOVER_CONTAINER_ID = 'globalPopoverContainer';
export const SCROLL_CONTAINER_ID = 'scrollContainer';

/**
 * Returns the popover container for poppers. Example: AddResolvers.jsx
 *
 * If your popper hides or shows too early during page dimension change (i.e. narrowing the page), maybe its parent is wrong. It may be:
 *   1. too deep in DOM tree, hence got scrolled out of view and got hidden too early, or
 *   2. too shallow in DOM tree hence got scrolled into view and got hidden too late
 * Changing your popover parent using a different ID (or null to use document) may fix the issue.
 *
 * @param {string|null} id - The HTML ID for the element. Passing '' or null will bypass the default parameter.
 * @returns {HTMLBodyElement} - The queried HTML element; will be document if
 *   1. The id is '' or null (but not undefined; that'll use POPOVER_CONTAINER_ID)
 *   2. The queried element does not exist in DOM
 */
let defaultContainerGetter = () => document.querySelector('body');

export const setDefaultContainerGetter = getContainer => {
  defaultContainerGetter = getContainer;
};

export const getPopoverContainer = (id = POPOVER_CONTAINER_ID) => {
  if (!id) return defaultContainerGetter();
  return document.querySelector(`#${id}`) || defaultContainerGetter();
};

export const getPopoverContainerWithFallback = id =>
  document.querySelector(`#${id}`) || getPopoverContainer();

export const getPopoverLvl2Container = () =>
  getPopoverContainerWithFallback(POPOVER_LVL2_CONTAINER_ID);

export const getGlobalPopoverContainer = () =>
  document.querySelector(`#${GLOBAL_POPOVER_CONTAINER_ID}`) ||
  getPopoverContainer();

// Not strictly necessary for modals (i.e. full screen), but needed for anything else that may cause scrolling:
export const portalPopover = elem =>
  ReactDOM.createPortal(elem, getPopoverContainer());

export const portalPopoverLvl2 = elem =>
  ReactDOM.createPortal(elem, getPopoverLvl2Container());

export const portalPopoverGlobal = elem =>
  ReactDOM.createPortal(
    elem,
    getPopoverContainerWithFallback(GLOBAL_POPOVER_CONTAINER_ID),
  );
